import { action, makeObservable, observable } from 'mobx';

import { FilterChipType } from 'components/TableFilters/FilterType';

export interface IBaseStoreClass {
  filters: FilterChipType[];
  page: number;
  take: number;
  totalItemCount: number;
  totalPageCount: number;
  addFilter: (value: FilterChipType) => void;
  removeFilter: (index: number) => void;
  clearFilters: () => void;
}

export class BaseStoreClass implements IBaseStoreClass {
  filters: FilterChipType[] = [];

  // pagination
  page = 1;
  take = 10;
  totalItemCount = 0;
  totalPageCount = 0;
  constructor() {
    makeObservable(this, {
      addFilter: action,
      clearFilters: action,
      filters: observable,
      page: observable,
      take: observable,
      totalItemCount: observable,
      totalPageCount: observable,
    });
  }
  addFilter = (value: FilterChipType) => {
    if (this.filters.find((f) => f.id === value.id)) {
      this.filters = this.filters.map((f) => (f.id === value.id ? value : f));
      return;
    }
    this.filters.push(value);
  };

  removeFilter = (index: number) => this.filters.splice(index, 1);

  clearFilters = () => {
    this.filters = [];
  };

  filtersQueryStr = (filters: FilterChipType[]) => {
    let q = '';
    filters.forEach((f) => (q += `&${f.id}=${f.value}`));
    return q;
  };
}
